import {RESET_AUTH_SIGN_PARAMS} from "../types";


const resetAuthSignParams= () => async (dispatch) => {
  dispatch({type: RESET_AUTH_SIGN_PARAMS, payload: {auth: {params: {signFirst: null, signAll:null}}}});
};
export default resetAuthSignParams;